import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const outcomes = ['Menos miedo cuando te despiertas (porque ya sabes qué hacer)', 'Más facilidad para volver a dormir', 'Menos rumiación nocturna', 'Energía más estable en la mañana'];
export function Results() {
  return <section className="py-20 bg-white px-4" data-id="element-190">
      <div className="max-w-4xl mx-auto text-center" data-id="element-191">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-slate-900 mb-12" data-id="element-192">
          Resultados que puedes esperar (realistas)
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-193">
          {outcomes.map((outcome, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 rounded-2xl bg-slate-50 border border-slate-100 flex flex-col items-center justify-center h-full hover:shadow-md transition-shadow" data-id="element-194">
              <Sparkles className="w-8 h-8 text-[#0d9488] mb-4 opacity-50" data-id="element-195" />
              <p className="text-lg font-medium text-slate-800" data-id="element-196">{outcome}</p>
            </motion.div>)}
        </div>

        <p className="text-slate-500 italic" data-id="element-197">
          (Sin prometer curas. Esto es regulación y práctica.)
        </p>
      </div>
    </section>;
}